import { useMutation, useQueryClient } from "react-query";

import { crearUsuarioSucursal, updateUsuarioSucursal, deleteUsuarioSucursal, updatePasswordUsuario} from '../../services/UsuarioSucursal';

import { toast } from 'react-hot-toast';
const queryKey = "usuario";

export const useUsuarioMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addUsuario = useMutation((body) => crearUsuarioSucursal(body), {
    onSuccess,
    onError: (err) => onError(err),
  });
  const updateUsuario = useMutation(
    (body) => updateUsuarioSucursal( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const updatePasswordUsuarioS = useMutation(
    (body) => updatePasswordUsuario( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removeUsuario = useMutation((id) => deleteUsuarioSucursal( id), {
    onSuccess,
    onError,
  });

  
  return { addUsuario, updateUsuario, removeUsuario, updatePasswordUsuarioS };
};
export default useUsuarioMutations;